import React, { useContext } from 'react';
import EnvCtx from "../../contexts/EnvCtx";
import LanguageSelector from "../../components/LanguageSelector";

const Header = () => {
    const { cciaa, logoCamera, existLingua } = useContext(EnvCtx);
    const cameraDiCommercioLink = cciaa.homeCamera ? cciaa.homeCamera : "#";

    return (
        <header className="header fixed-top">
            <nav className="navbar row p-3 align-items-center" style={{ backgroundColor: cciaa ? cciaa.colore_header : "" }}>
                <div className="row">
                    <div className="col-11 mx-auto text-center">
                        <a href={cameraDiCommercioLink} target="_blank" rel="noreferrer">
                            {logoCamera ? (
                                <img src={logoCamera} alt="Logo camera di commercio" className="logo-image img-fluid" loading="lazy"/>
                            ) : (
                                <img src={require('../../assets/images/BO.png')} alt="default Logo camera di commercio" className="logo-image img-fluid" loading="lazy" />
                            )}
                        </a>
                    </div>
                    {existLingua === true && (
                        <div className="col-1 mx-auto text-center justify-content-center align-self-center">
                            <LanguageSelector />
                        </div>
                    )}
                </div>
            </nav>
        </header>
    );
};

export default Header;
